import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';
import Typography from "@material-ui/core/Typography";
import { spacing } from "@material-ui/system";
import { Box, Switch } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from '@material-ui/core/FormGroup';
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from '@material-ui/core/Checkbox';
import { DropzoneArea } from "material-ui-dropzone";
import Divider from '@material-ui/core/Divider';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Geographical from "../../../constants/Geographical.json";
import { useStyles } from "../../../styles/styles";
import { LoadApplicationTemplate, ConfigApplicaitonTemplate, ApplicationStoreAction } from '../../../redux/actions/CustomerAction';
import ApplicationTemplate from "../../../components/partials/ApplicationTemplate/ApplicationTemplate";
import ApplicationsListPanel from "../common/ApplicationsListPanel";
import ErrorComponent from '../../ErrorComponent';
import { useDispatch, useSelector } from 'react-redux';
import parse from 'html-react-parser';
const defaultValuesLicensePOE = {
   status: false,
   districtFilter:[],
   municipalityFilter:[]

};
const styles = {
  root: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none',
    paddingTop: '25px',
    color: '#FFFFFF'
  },
  customButton: {
    marginTop: "15px",
    marginBottom: "30px",
    backgroundColor: "#67a8e4",
    textTransform: "Capitalize",
    clear: "both",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "30px",
    paddingRight: "30px",

    "&:hover": {
      background: "#67a8e4",
    },
  },
  switchRoot: {
    width: "50px!important",
    height: "24px!important",
    padding: "0px!important",
  },
  switchBase: {
    color: "#818181!important",
    padding: "1px!important",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#23bf58!important",
      },
    },
  },
  thumb: {
    color: "white!important",
    width: "20px!important",
    height: "20px!important",
    margin: "1px!important",
  },
  track: {
    borderRadius: "20px!important",
    backgroundColor: "#818181!important",
    opacity: "1 !important!important",
    "&:after, &:before": {
      color: "white!important",
      fontSize: "11px!important",
      position: "absolute!important",
      top: "6px!important",
    },
    "&:after": {
      content: "'Yes'",
      left: "8px!important",
    },
    "&:before": {
      content: "'No'",
      right: "7px!important",
    },
  },
  checked: {
    color: "#23bf58 !important",
    transform: "translateX(26px) !important",
  },
  verticalGap: {
    '@media (max-width: 500px)': {
      marginTop: "20px"
    },
  },
  notifyUser: {

  }
};
export default function ApplicationComponent(props) {
  const history = useHistory();
  const focusDiv = useRef();
  const classes = useStyles();
  const [geos, setGeo] = useState([]);
  const [template, setTemplate] = useState(0);
  const [applicationTypes, setApplicationTypes] = useState([]);
  const [checkStatus, setCheckStatus] = useState(false);
  const [status, setStatus] = useState(false);
  const [configItem, setConfigItem] = useState(''); // for template selection
  const [hydroItem, setHydroItem] = useState(''); // for template selection
  const [dropZoneValue, setDropZoneValue] = useState({});
  const [result, setResult] = useState([]);
  const [flagger, setFlagger] = useState(true);
  const [accessRestriction, setAccessRestriction] = useState(false);
  const [applicationAccessMessage, setApplicationAccessMessage] = useState("");
  const [state, setState] = React.useState({
    checkedA: false
  });
  const [formValuesLicensePOE, setFormValuesLicensePOE] = useState(defaultValuesLicensePOE);
  const [validationError, setValidationError] = useState([]);
  const applicationTemplateFields = useSelector(state => state.customerDetails.applicationTemplateFields);
  const applicationStore = useSelector(state => state.customerDetails.application);
  const [applicationAccessResponse, setApplicationAccessResponse] = useState('');
  const [applicationResponse, setApplicationResponse] = useState('');
  const [eastError, setEastError] = useState("");
  const [eastStatus, setEastStatus] = useState(false);
  const [westError, setWestError] = useState("");
  const [westStatus, setWestStatus] = useState(false);
  const [northError, setNorthError] = useState("");
  const [northStatus, setNorthStatus] = useState(false);
  const [southError, setSouthError] = useState("");
  const [southStatus, setSouthStatus] = useState(false);
  const [stateFlag, setStateFlag] = useState(false);
  const [districtFlag, setDistrictFlag] = useState(false);
  const [disableButtonSubmit, setDisableButtonSubmit] = useState(false);
  const dispatch = useDispatch();
  const handleInputChangeApplicationCreate = (e) => {
    e.preventDefault();

    const { name, value } = e.target;
    applicationTypes.map((item) => {
      if (item.id == value) {
        setConfigItem(item);
      }
    })

    if (value != 0) {
      setResult([]);
      setDropZoneValue({});
      setStatus(false);
      setCheckStatus(false);
      dispatch(LoadApplicationTemplate(value, setFlagger, flagger, setResult, formValuesLicensePOE, setFormValuesLicensePOE, defaultValuesLicensePOE, setTemplate, geos));
    }

  }
  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    if (name == "status") {
      if (!checked) {
        setCheckStatus(true);
      } else {
        setCheckStatus(false);
      }
      setFormValuesLicensePOE({
        ...formValuesLicensePOE,
        [name]: checked,
        'for_your_confirmation': checked == true ? 1 : 0
      });
    } else {
      setFormValuesLicensePOE({
        ...formValuesLicensePOE,
        [name]: value,
      });
    }




  };
  const handleInputChangeDropzone1 = (e) => {
    e.preventDefault();

    
    setFormValuesLicensePOE({
      ...formValuesLicensePOE,
      ["license_poe_docs"]: e,
    });
  };

  const fhandleSubmitLicensePOE = (event) => {
    
    event.preventDefault();
    setApplicationResponse('')
    setStatus(true);
    if (!formValuesLicensePOE.status) {
      setCheckStatus(true);
      return true;
    }
    setDisableButtonSubmit(true)
    // if (dropZoneValue['application_letter'].length == 0) {
    //   setCheckStatus(true);
    //   return true;
    // }

    const uploadData = new FormData();
    for (var k in dropZoneValue) {
      if (dropZoneValue.hasOwnProperty(k)) {
        Array.from(dropZoneValue[k]).forEach((image_file) => {

          uploadData.append(k + '[]', image_file)
        })
      }
    }
    for (var applicaitonFieldKey in formValuesLicensePOE) {
      uploadData.append(applicaitonFieldKey, formValuesLicensePOE[applicaitonFieldKey]);
    }
    dispatch(ApplicationStoreAction(template, uploadData, setApplicationResponse, setFlagger, history, setDisableButtonSubmit));
    if (!applicationResponse.success) {
      focusDiv.current.scrollIntoView();
    }
    
  };
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };
  useEffect(() => {
    ConfigApplicaitonTemplate().then(res => {
      if (!res.success) {
        setAccessRestriction(true);
        setApplicationAccessResponse(res)
      }
      setResult(applicationTemplateFields.data != undefined ? applicationTemplateFields.data : [])
      setApplicationTypes([{ "id": 0, "name": "Select Application Type" }, ...res.data]);
      setFormValuesLicensePOE({ ...formValuesLicensePOE, state_1: [0], district_1: [0], state_2: [0], district_2: [0], state_3: [0], district_3: [0], municipality_1:[0],municipality_2:[0],municipality_3:[0]})
      

    });
    
 
    setGeo(Geographical)
    return () => {
      setGeo({})

    };


  }, []);

  return (
    <>
      {accessRestriction && <Grid container item xs={12}>
        <Grid item xs={12}>
          {applicationAccessResponse != "" && < ErrorComponent error={applicationAccessResponse.message} />}

        </Grid>
      </Grid>}
      {!accessRestriction && <Grid container item xs={12} >
        <Grid item xs={12} ref={focusDiv}>
          {applicationResponse != "" && applicationResponse.success == false && < ErrorComponent error={applicationResponse.message} />}

        </Grid>
      </Grid>}
      {!accessRestriction && <Grid container item xs={12} >
        <Grid item xs={12} >
          {applicationStore != "" && applicationResponse.success == true &&
            <span>{applicationStore.message}</span>}

        </Grid>
      </Grid>}
      {!accessRestriction &&
        <>
          <form onSubmit={fhandleSubmitLicensePOE} style={{ textAlign: "left" }}>

            <Grid container item xs={12}>
              <Grid item xs={12}  md={6}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel>Application Type</InputLabel>
                  {applicationTypes != '' &&
                    <Select
                      name="application-create"
                      label="Application License Type"
                      value={template}
                      onChange={(event) => handleInputChangeApplicationCreate(event)}
                      inputlabelprops={{
                        shrink: true,
                      }}
                    >
                      {/* <MenuItem key={0} value={0}>
                        Select Application Type
                      </MenuItem> */}
                      {applicationTypes.map((item) => {

                        return <MenuItem key={item.id} value={item.id} xyz={item.name}>
                          {item.name}
                        </MenuItem>
                      })}

                    </Select>
                  }
                </FormControl>
              </Grid>
            </Grid>
            <Grid container item xs={12}>

              {result != undefined && result.length != 0 && template != 0 &&
                <>
                  <Grid item xs={12}>
                    <div>
                      <Typography variant="subtitle1" component="div" style={{ position: "relative", marginTop: "15px", marginBottom: "15px", fontWeight: "bold" }} gutterBottom>
                        {applicationTypes.map((item) => {
                          return (item.id == template)?item.name : ''
                        })}
 
                      </Typography>
                      <Typography variant="subtitle1" component="div" style={{ position: "relative", marginTop: "15px", marginBottom: "15px", fontWeight: "bold" }} gutterBottom>
                        {applicationTypes.map((item) => {
                          return (item.id == template && (item.id == 10 || item.id == 11))?parse(item.description) : ''
                        })}

                      </Typography>
                    </div>
                  </Grid><Grid item xs={12} sm={4}>
                    <FormControl variant="outlined" className={[classes.formControl, classes.verticalGap]}>
                      <TextField
                        id="name_of_the_project_of_electricity"
                        name="name_of_the_project_of_electricity"
                        margin="normal"
                        type="text"
                        variant="outlined"
                        label="Name of the project of electricity"
                        value={formValuesLicensePOE.name_of_the_project_of_electricity}
                        onChange={handleInputChange}
                        inputlabelprops={{
                          shrink: true,
                        }}
                    focused
                      />
                    </FormControl>
                    <br />
                    {status && formValuesLicensePOE.name_of_the_project_of_electricity == "" && <span style={{ color: "red" }}>Please fill up this field Name of the project of electricity.</span>}

                  </Grid>
                </>
              }
              <Grid container item xs={12}>
                {result != undefined && result.length != 0 && template != 0 &&
                  <>{result.map((element,rootIndex) => {

                    if (element.children != undefined) {

                      let item = [];
                      element.children.map((secondLevelElement) => {
                        secondLevelElement.fields.map((secondLevelField) => {
                          item.push(secondLevelField);


                        })
                      })

                        
                      
                      
                      
                      
                      element.fields.map((firstLevelField) => {
                        item.push(firstLevelField);

                      })
                     

                      return item.map((firstLevelField, index) => {

                        return (<ApplicationTemplate key={index} setFormValuesLicensePOE={setFormValuesLicensePOE} formValuesLicensePOE={formValuesLicensePOE} setDropZoneValue={setDropZoneValue} dropZoneValue={dropZoneValue} field={firstLevelField} configItem={configItem} hydroItem={hydroItem} setHydroItem={setHydroItem} checkStatus={checkStatus} setCheckStatus={setCheckStatus} status={status} setStatus={setStatus}
                          eastError={eastError} setEastError={setEastError} eastStatus={eastStatus} setEastStatus={setEastStatus}
                          westError={westError} setWestError={setWestError} westStatus={westStatus} setWestStatus={setWestStatus}
                          northError={northError} setNorthError={setNorthError} northStatus={northStatus} setNorthStatus={setNorthStatus}
                          southError={southError} setSouthError={setSouthError} southStatus={southStatus} setSouthStatus={setSouthStatus} stateFlag={stateFlag} setStateFlag={setStateFlag} districtFlag={districtFlag} setDistrictFlag={setDistrictFlag}/>)
                      })

                    } else {
                      return element.fields.map((firstLevelField, index) => {
                       
                        
                        let groupName = (index==0)?element.name:null;
                        let groupDescription= (index==0)?element.description:null;
                        
                       
                        return (<ApplicationTemplate key={rootIndex + '' + index} setFormValuesLicensePOE={setFormValuesLicensePOE} formValuesLicensePOE={formValuesLicensePOE} setDropZoneValue={setDropZoneValue} dropZoneValue={dropZoneValue} field={firstLevelField} configItem={configItem} hydroItem={hydroItem} setHydroItem={setHydroItem} checkStatus={checkStatus} setCheckStatus={setCheckStatus} status={status} setStatus={setStatus}
                          eastError={eastError} setEastError={setEastError} eastStatus={eastStatus} setEastStatus={setEastStatus}
                          westError={westError} setWestError={setWestError} westStatus={westStatus} setWestStatus={setWestStatus}
                          northError={northError} setNorthError={setNorthError} northStatus={northStatus} setNorthStatus={setNorthStatus}
                          southError={southError} setSouthError={setSouthError} southStatus={southStatus} setSouthStatus={setSouthStatus} groupName={groupName} groupDescription={groupDescription} stateFlag={stateFlag} setStateFlag={setStateFlag} districtFlag={districtFlag} setDistrictFlag={setDistrictFlag}/>)
                      })
                    }


                  })}</>
                }
                {configItem != "" && result != undefined && result.length != 0 && <Grid container item xs={9} style={{ marginTop: "30px" }}>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox checked={formValuesLicensePOE.status}
                      onChange={handleInputChange}
                      name="status"
                      color="primary" />} label="The fact mentioned above are correct and true. In case if if is found false I/we
                    am/are prepared to bear according to law." required />
                    {checkStatus && !formValuesLicensePOE.status && <span style={{ color: "red" }}>You must tick the checkbox for submission of applicaiton</span>}
                  </FormGroup>
                </Grid>}

              </Grid>
              {configItem != "" && result != undefined && result.length != 0 &&
                <Grid item xs={12} >
                <Button className={classes.customButton} variant="contained" color="primary" type="submit" style={{ marginTop: "15px", marginBottom: "15px" }} disabled={disableButtonSubmit}>
                    Submit
                  </Button>
                </Grid>
              }
            </Grid>
          </form>

        </>
      }
      {/* <ApplicationsListPanel/> */}
    </>
  )


};